import Choices from 'choices.js';
// import 'choices.js/public/assets/styles/choices.min.css'; // Optional if you want the default styles

export function choicesJS() {
  const elements = document.querySelectorAll('.multi-select-input');
  if (!elements.length) return;

  const removeLabel = 'Fjern';

  elements.forEach((element) => {
    const placeholderValue = element.dataset.placeholder || 'Vælg…';
    const searchPlaceholderValue = element.dataset.searchPlaceholder || 'Søg…';

    const choices = new Choices(element, {
      removeItemButton: true,
      itemSelectText: '',
      searchEnabled: true,
      placeholderValue: placeholderValue,
      searchPlaceholderValue: searchPlaceholderValue,
      callbackOnCreateTemplates: function (template, classNames) {
        return {
          item: (classNames, itemData) => {
            return template(`
              <div class="choices__item" data-item data-id="${itemData.id}" data-value="${itemData.value}">
                <span>${itemData.label}</span>
                <button 
                  type="button" 
                  class="choices__button" 
                  data-button=""
                  aria-label="${removeLabel} ${itemData.label}">
                </button>
              </div>
            `);
          },
          choice: (classNames, choiceData) => {
            return template(`
              <button 
                class="dropdown-option" 
                role="option" 
                aria-selected="${choiceData.selected ? 'true' : 'false'}" 
                data-choice 
                data-id="${choiceData.id}" 
                data-value="${choiceData.value}">
                ${choiceData.label}
              </button>
            `);
          }
        };
      }
    });

    element.addEventListener('change', () => {
      // console.log(`Selected values in: ${element.name}`, choices.getValue(true));
    });
  });
}

export default choicesJS;
